import { WebRTCPlayer } from '@liveauctioneers/hammer-ui-core/webRTCPlayer';
import { cn } from '@liveauctioneers/hammer-ui-theme/cn';

import { useFetchStreamId, useStreamIdPolling } from '@/hooks/useStreamIdPolling';
import { useAppSelector } from '@/redux/hooks';
import { getAntMediaHostname } from '@/redux/modules/config';
import { hasVideoStream } from '@/redux/modules/video';

import { MessageScrollerContainer } from '../MessageScrollerContainer/MessageScrollerContainer';

type Props = {
    catalogId: number;
    isThreeColumn: boolean;
};

export const BiddingConsoleRightSection = ({ catalogId, isThreeColumn }: Props) => {
    const streamId = useStreamIdPolling(catalogId);
    const catalogHasVideoStream = useAppSelector((state) => hasVideoStream(state, catalogId));
    const fetchStreamId = useFetchStreamId(catalogId);
    const antMediaHostname = useAppSelector(getAntMediaHostname);

    return (
        <div
            className={cn('grid h-full grid-rows-1 flex-col gap-md', {
                'grid-rows-[max-content_1fr]': catalogHasVideoStream,
            })}
        >
            {catalogHasVideoStream && (
                <WebRTCPlayer
                    className="aspect-auto min-h-[226px] rounded-sm"
                    debug={false}
                    fetchStreamId={fetchStreamId}
                    hostname={antMediaHostname}
                    streamId={streamId}
                />
            )}
            {isThreeColumn && (
                <div className="h-full rounded-sm bg-background-primary">
                    <MessageScrollerContainer catalogId={catalogId} />
                </div>
            )}
        </div>
    );
};
